import { render, staticRenderFns } from "./DeleteServiceCategoryModal.vue?vue&type=template&id=2e50d3e8&"
import script from "./DeleteServiceCategoryModal.vue?vue&type=script&lang=js&"
export * from "./DeleteServiceCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports